module.exports = __webpack_public_path__ + "static/media/company-plus.f6d17796.svg";